module.exports = __webpack_public_path__ + "ffd570092bef836cb362e16ecf79c843.png";